export default "__VITE_ASSET__07351cbc__"